<template>
  <VWidget
    :title="$t('Taxonomy settings')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-text-field
        v-model.number="taxonomy.order"
        :label="$t('Sort order')"
        mask="######################"
        outline/>

      <application-select
        v-model="taxonomy.application"
      />

      <image-upload v-model="taxonomy.image_url"/>
    </div>
  </VWidget>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'
import ApplicationSelect from '@/components/form/ApplicationSelect'

export default {
  name: 'TaxonomySingleSettings',

  components: {
    ApplicationSelect,
    ImageUpload
  },
  props: {
    taxonomy: {
      type: Object,
      required: true
    }
  },

  computed: {
    verrors () {
      return field => {
        if (!this.taxonomy.errors) {
          return []
        }
        return this.taxonomy.errors
          .filter(obj => obj.field === field)
          .map(obj => obj.message)
          .flat()
      }
    }
  }
}
</script>
